// components/settings/Settings.jsx
import React, { useState } from 'react';
import GeneralSettings from './GeneralSettings';

const Settings = () => {
    const [activeSection, setActiveSection] = useState('general');

    return (
        <div className="p-8">
            <h2 className="text-2xl font-bold mb-6">Settings</h2>
            
            {/* Settings Navigation */}
            <div className="flex gap-4 mb-6">
                <button 
                    onClick={() => setActiveSection('general')}
                    className={`px-4 py-2 rounded-lg ${
                        activeSection === 'general' 
                            ? 'bg-blue-100 text-blue-700' 
                            : 'text-gray-600 hover:bg-gray-100'
                    }`}
                >
                    General
                </button>
            </div>

            {/* Settings Content */}
            <div className="bg-white rounded-lg shadow p-6">
                {activeSection === 'general' && <GeneralSettings />}
            </div>
        </div>
    );
};

export default Settings;